import Vue from 'vue';
import {handleErrors} from '@/services/ErrorHandling';

const self = Vue.prototype;

export default {
  getFiltered(query, page = 1, perPage = 10) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminSettingsDepartments + `?page=${page}&per_page=${perPage}&${query}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  create(body) {
    return new Promise((resolve, reject) => {
      self.axios.post(self.$apiRouter.adminSettingsDepartments, body)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  update(body) {
    return new Promise((resolve, reject) => {
      self.axios.post(self.$apiRouter.adminSettingsDepartments + '/update', body)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  delete(id) {
    return new Promise((resolve, reject) => {
      self.axios.delete(self.$apiRouter.adminSettingsDepartments + `/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  get(id) {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminSettingsDepartments + `/${id}`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getPermissionsMap() {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminSettingsDepartments + `/permissions-map`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          reject(error)
        })
    })
  },
  getCurrencyDependentSettingsMap() {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminSettingsDepartments + `/currency-dependent-settings-map`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  },
  getShippingServicesMap() {
    return new Promise((resolve, reject) => {
      self.axios.get(self.$apiRouter.adminSettingsDepartments + `/shipping-services-map`)
        .then(response => {
          resolve(response)
        })
        .catch(error => {
          handleErrors(error, reject)
        })
    })
  }
}
